import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { MODULE_VERSION_RESOURCES_COLUMN_ID } from "../constants";
import { ModuleVersionResourceRow } from "../types";
import ModuleVersionResourcesTableNameCell from "./NameCell";

export const MODULE_VERSION_RESOURCES_TABLE_CELLS: Record<
  MODULE_VERSION_RESOURCES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionResourceRow>) => JSX.Element
> = {
  [MODULE_VERSION_RESOURCES_COLUMN_ID.NAME]: ModuleVersionResourcesTableNameCell,
};
